/**
 * @module:  沃客信未读消息
 * @author: Liang Huang
 * @date: 2019-08-22 10:07:54
 */
import Cookies from 'js-cookie';
/**
 * 初始化未读消息socket实例
 * @param {object} data
 * @param {string} [data.usergroup_id] 用户所属公司
 * @param {string} [data.options] 被选中的key数组字符串,多个用,分隔
 * @param {string} [data.options.reconnectDelay] socket连接失败后，重连的延时，单位：ms
 */

export function initUnreadSocket(data) {
  const {
    usergroup_id,
    options
  } = data;
  initWebSocket(usergroup_id, options);
} // 最大连接数

const MAX_CONNECT_TIMES = 20;
const DEFAULT_DELAY = 10000;

class Socket {
  constructor(url, usergroup_id, options = {}) {
    this.leftCont = MAX_CONNECT_TIMES; // 是否是连接状态

    this.isConnect = false; // 当前socket实例

    this.socket = null; // 间隔心跳对象

    this.heartbeatInterval = null;
    this.url = url;
    this.token = Cookies.get('cwsso_token');
    this.usergroup_id = usergroup_id;
    this.options = {
      reconnectDelay: options.reconnectDelay || DEFAULT_DELAY
    };

    if (this.token) {
      // 连接
      this.createConnect();
    }
  }

  createConnect() {
    if (this.leftCont <= 0) {
      setTimeout(() => {
        this.leftCont = MAX_CONNECT_TIMES;
        this.reConnect();
      }, this.options.reconnectDelay);
      return;
    }

    this.connect();
  } // 初始化订阅


  subscription() {
    const params = {
      action: 'register',
      body: {
        event: 'event_unread_count',
        token: this.token,
        usergroup_id: this.usergroup_id
      }
    };
    this.sendMsg(params);
    this.heartbeat();
    this.heartbeatInterval = setInterval(() => this.heartbeat(), 30 * 1000);
  }

  connect() {
    this.socket = new WebSocket(this.url);

    this.socket.onopen = () => {
      this.isConnect = true; // console.log('register');

      this.subscription();
    };

    this.socket.onmessage = this.messageHander.bind(this);

    this.socket.onerror = () => {// console.log('socket error observed:', err);
    };

    this.socket.onclose = evt => {
      this.isConnect = false;
      if (this.heartbeatInterval) clearInterval(this.heartbeatInterval);
      this.reConnect();
    };
  }

  reConnect() {
    --this.leftCont;
    this.createConnect();
  }

  sendMsg(data) {
    if (this.socket && this.isConnect) {
      try {
        this.socket.send(JSON.stringify(data));
      } catch (error) {
        console.log(error);
      }
    }
  }
  /**
   * 发送心跳包
   *
   * @memberof Socket
   */


  heartbeat() {
    this.sendMsg({
      action: 'keepalive',
      body: {
        content: 'ping'
      }
    });
  }
  /**
   * 接收消息
   *
   * @param {*} evt 消息体
   * @memberof Socket
   */


  messageHander(evt) {
    try {
      const data = JSON.parse(evt.data);
      const {
        event,
        type,
        usergroup_id,
        user_id,
        createat,
        unread_count
      } = data;

      if (event === 'event_unread_count') {
        // 处理未读消息的显示
        renderUnread(+unread_count);
      }
    } catch (error) {}
  }

}

function initWebSocket(usergroup_id, options) {
  new Socket(WSS_DOMAIN, usergroup_id, options);
}
/**
 * 渲染未读消息dom
 * @param {*} num 未读消息数量
 */


function renderUnread(num) {
  const dom = document.querySelector('.menu-ykx');
  const unread = document.getElementById('wkx-unread-num');

  if (dom.contains(unread)) {
    unread.innerHTML = renderNum(num);
  } else {
    dom.appendChild(generateHTML(num));
  }
} // 生成样式


function generateStyle() {
  return `position: absolute;
  right: 0;
  top: 4px;
  display: block;
  background-color: #f00;
  color: #fff;
  font-size: 12px;
  text-align: center;
  border-radius: 10px;
  white-space: nowrap;
  padding: 0 6px;
  overflow: hidden;
  min-width: 20px;
  font-weight: normal;
  box-sizing: border-box;
  `;
}

function renderNum(num) {
  if (num > 99) {
    return '99+';
  } else if (+num === 0) {
    return '';
  }

  return num.toString();
} // 生成html


function generateHTML(num) {
  const span = document.createElement('span');
  span.innerHTML = renderNum(num);
  span.id = 'wkx-unread-num';
  span.setAttribute('style', generateStyle());
  return span;
}